export default __webpack_public_path__ + "static/media/SMS component.2d1b0e50.svg";